import { useRef } from "react";
import type { StaffWithdrawQuery } from "../../types";
import { Toast } from "antd-mobile";
import { uploadImage } from "@/api/upload";

const BRAND = "#FF6B35";

interface Props {
  value: StaffWithdrawQuery;
  onChange: (val: StaffWithdrawQuery) => void;
}

export function UploadPayImg({ value, onChange }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      Toast.show({ icon: "loading", content: "上传中..." });
      const url = await uploadImage(file);
      onChange({ ...value, qrcode_url: url });
      Toast.show({ icon: "success", content: "上传成功", duration: 1200 });
    } finally {
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="bg-white rounded-2xl p-4 space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-base font-bold text-gray-900">上传收款码</span>
        {value.qrcode_url && (
          <button
            onClick={() => inputRef.current?.click()}
            className="text-xs font-medium active:opacity-70"
            style={{ color: BRAND }}
          >
            重新上传
          </button>
        )}
      </div>

      {!value.qrcode_url ? (
        <button
          onClick={() => inputRef.current?.click()}
          className="w-[88px] h-[88px] rounded-xl border border-dashed border-gray-200 flex flex-col items-center justify-center active:scale-[0.98] transition-all"
        >
          <i className="ri-add-line text-xl text-gray-300" />
          <span className="text-xs text-gray-400 mt-1">点击上传</span>
        </button>
      ) : (
        <div
          className="w-[88px] h-[88px] rounded-xl overflow-hidden active:scale-[0.98] transition-all cursor-pointer relative group"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={value.qrcode_url} alt="" className="w-full h-full object-cover" onClick={() => inputRef.current?.click()} />
          {/* 查看大图 */}
          <div
            className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
            onClick={() => window.open(value.qrcode_url, "_blank")}
          >
            <i className="ri-zoom-in-line text-white text-lg" />
          </div>
        </div>
      )}

      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFileChange} />
    </div>
  );
}
